import React from 'react'
import { List, ListItem } from '@astryxdesign/core/List'
import { IconButton } from '@astryxdesign/core/IconButton'
import { HStack } from '@astryxdesign/core/Layout'
import { ChevronUp, ChevronDown, Plus, Trash2 } from 'lucide-react'

interface ChapterSidebarProps {
  chapters: StoryChapter[]
  activeChapterId: string | null
  onSelectChapter: (chapterId: string) => void
  onAddChapter: () => void
  onDeleteChapter: (chapterId: string) => void
  onMoveChapter: (chapterId: string, direction: 'up' | 'down') => void
  header?: string
  showAddChapter?: boolean
}

export default function ChapterSidebar({
  chapters,
  activeChapterId,
  onSelectChapter,
  onAddChapter,
  onDeleteChapter,
  onMoveChapter,
  header = 'Chapters',
  showAddChapter = true
}: ChapterSidebarProps): React.JSX.Element {
  const sorted = [...chapters].sort((a, b) => a.position - b.position)

  return (
    <List density="compact" hasDividers header={header}>
      {sorted.map((chapter, index) => (
        <ListItem
          key={chapter.id}
          label={chapter.title || `Chapter ${index + 1}`}
          isSelected={chapter.id === activeChapterId}
          onClick={() => onSelectChapter(chapter.id)}
          endContent={
            <HStack gap={1} align="center">
              <IconButton
                variant="ghost"
                size="sm"
                icon={<ChevronUp size={14} />}
                label="Move chapter up"
                tooltip="Move up"
                isDisabled={index === 0}
                onClick={(e) => {
                  e.stopPropagation()
                  onMoveChapter(chapter.id, 'up')
                }}
              />
              <IconButton
                variant="ghost"
                size="sm"
                icon={<ChevronDown size={14} />}
                label="Move chapter down"
                tooltip="Move down"
                isDisabled={index === sorted.length - 1}
                onClick={(e) => {
                  e.stopPropagation()
                  onMoveChapter(chapter.id, 'down')
                }}
              />
              <IconButton
                variant="ghost"
                size="sm"
                icon={<Trash2 size={14} />}
                label="Delete chapter"
                tooltip="Delete chapter"
                isDisabled={sorted.length <= 1}
                onClick={(e) => {
                  e.stopPropagation()
                  onDeleteChapter(chapter.id)
                }}
              />
            </HStack>
          }
        />
      ))}
      {showAddChapter && (
        <ListItem label="New chapter" startContent={<Plus size={14} />} onClick={onAddChapter} />
      )}
    </List>
  )
}
